import { TokenLogout } from 'API/Logout/logout';
import axios from 'axios';

const url = process.env.REACT_APP_BASE_URL;

export const AgreementList = async (page, limit, editValues, setIsloading, setErrorMsg, setResList, setTotalCount) => {
  setIsloading(true);
  try {
    await axios
      .post(
        `${url}/ds/agreement/list?page=${page}&limit=${limit}`,
        {
          ...(editValues.date_from && { from_date: editValues.date_from }),
          ...(editValues.date_to && { to_date: editValues.date_to }),
          ...(editValues.username && { name: editValues.username }),
          ...(editValues.bankname !== 'select' && { bank_name: editValues.bankname }),
          ...(editValues.filterstate !== 'select' && { retail_state: editValues.filterstate }),
          ...(editValues.filterdistrict !== 'select' && editValues.filterdistrict !== '' && { retail_district: editValues.filterdistrict })
        },
        {
          headers: {
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setTotalCount(res.data.total_count);
          setResList(res.data.ds_users);
          setIsloading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setIsloading(false);
  }
};

export const AgreementLink = async (data, setIsloading, setSuccessMsg, setErrorMsg, refunction) => {
  setIsloading(true);
  try {
    await axios
      .post(
        `${url}/ds/agreement/link`,
        {
          user_id: data.user_id,
          user_type: data.user_type
        },
        {
          headers: {
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setSuccessMsg(res.data.message);
          setIsloading(false);
          setTimeout(() => {
            refunction();
          }, 1000);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
    setIsloading(false);
  }
};

export const AgreementStatusCheck = async (data, setIsloading, setSuccessMsg, setErrorMsg, refunction) => {
  setIsloading(true);
  try {
    await axios
      .post(
        `${url}/ds/agreement/status`,
        {
          user_id: data.user_id
        },
        {
          headers: {
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setSuccessMsg(res.data.message);
          setIsloading(false);
          setTimeout(() => {
            refunction();
            console.log('refunction');
          }, 1000);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
        setTimeout(() => {
          refunction();
          console.log('refunction');
        }, 1000);
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
    setTimeout(() => {
      refunction();
      console.log('refunction');
    }, 1000);
    setIsloading(false);
  }
};

export const RenewAgreement = async (data, setIsloading, setSuccessMsg, setErrorMsg, refunction) => {
  setIsloading(true);
  try {
    await axios
      .post(
        `${url}/ds/agreement/reactivate`,
        { user_id: data.user_id },
        {
          headers: {
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setSuccessMsg(res.data.message);
          setIsloading(false);
          setTimeout(() => {
            refunction();
            console.log('refunction');
          }, 1000);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
        setTimeout(() => {
          refunction();
          console.log('refunction');
        }, 1000);
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setErrorMsg(error.response ? error.response.data.error : 'Something went wrong');
    setTimeout(() => {
      refunction();
      console.log('refunction');
    }, 1000);
    setIsloading(false);
  }
};
